<div fxLayout="row" class="line" style="height: 100%; width: 100%">
   <div
      fxLayout="column"
      fxFlex="1 1 100"
      class="info"
      *ngIf="!(isLineAIdle$ | async)"
      [ngClass]="{
         hold: isLineAOnHold$ | async
      }"
   >
      <div fxFlex="1 1 80" (click)="toggleView()">
         <div fxFlex="100" fxLayout="column" [ngClass]="{ holdtext: isLineAOnHold$ | async }">
            <div
               class="skill"
               [ngClass]="{
                  'skill-connected':
                     (isCallInProgress$ | async) &&
                     !(toggleExpertView || (showCallInfo$ | async) || (showHistory$ | async))
               }"
               If="(currentSourceLineStateModel$ | async)?.dn !== ''"
            >
               <samweb-skill-short-info
                  kendoTooltip
                  [title]="((callInfo$ | async).queueId | skillIdToShortSkillInfo$ | async)?.skillName"
                  *ngIf="callInfo$ | async"
                  [skillConfiguration]="(callInfo$ | async).queueId | skillIdToShortSkillInfo$ | async"
                  class="skill-info"
               >
               </samweb-skill-short-info>
            </div>
            <div
               fxFlex="1 1 90"
               fxLayout="column"
               *ngIf="
                  !toggleExpertView && !(showCallInfo$ | async) && !(showHistory$ | async) && (callInfo$ | async);
                  let lineInfo
               "
               class="large-view"
            >
               <div fxFlex="1 1 60" class="avatar" [ngClass]="{ 'avatar-connected': (isCallInProgress$ | async) }">
                  <samweb-avatar
                     class="sam-padding"
                     [dn]="lineInfo.peerId"
                     [useSamwinShape]="false"
                     [useRoundShape]="true"
                     [showPresenceStatus]="false"
                     fxFlex="0 0 100"
                     *ngIf="lineInfo.peerId !== ''"
                  >
                  </samweb-avatar>
               </div>
               <div fxFlex="1 1 40" class="lineInfo">
                  <div *ngIf="lineInfo.peerId | isAnonymous" class="container" fxFlex="1 1 auto">
                     <div class="line-name">
                        {{ 'common.calling.unknown_number' | translate }}
                     </div>
                  </div>
                  <div *ngIf="!(lineInfo.peerId | isAnonymous) && lineInfo.peerId !== ''" fxLayout="column">
                     <div *ngIf="lineInfo.peerName !== ''" class="container">
                        <div class="line-name">
                           {{ lineInfo.peerName }}
                        </div>
                     </div>
                     <div *ngIf="lineInfo.peerId !== ''" fxFlex="1 1 auto" class="container">
                        <div [class.line-name]="lineInfo.peerName === ''">
                           {{ lineInfo.peerId }}
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <div
               *ngIf="
                  (featureEnabled$ | async) && (toggleExpertView || (showCallInfo$ | async) || (showHistory$ | async))
               "
               fxFlex="1 1 90"
               fxLayout="column"
               class="small-view"
            >
               <div
                  fxLayout="row"
                  class="padding-left"
                  *ngIf="callInfo$ | async; let lineInfo"
                  style="align-items: start"
               >
                  <div fxFlex="1 1 20">
                     <samweb-avatar
                        [dn]="lineInfo.peerId"
                        [useSamwinShape]="false"
                        [useRoundShape]="true"
                        [showPresenceStatus]="false"
                        fxFlex="0 0 100"
                        *ngIf="lineInfo.peerId !== ''"
                        class="small"
                     >
                     </samweb-avatar>
                  </div>
                  <div class="line-info" style="display: table !important; height: 100%">
                     <div style="display: table-cell !important; vertical-align: middle; padding-left: 0.5em">
                        <div *ngIf="lineInfo.peerId | isAnonymous" class="line-name">
                           {{ 'common.calling.unknown_number' | translate }}
                        </div>
                        <div *ngIf="!(lineInfo.peerId | isAnonymous) && lineInfo.peerId !== ''">
                           <div *ngIf="lineInfo.peerName !== ''" class="line-name">
                              {{ lineInfo.peerName }}
                           </div>
                           <div *ngIf="lineInfo.peerId !== ''" class="line-peer">
                              {{ lineInfo.peerId }}
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="ici-info sam-margin" *ngIf="toggleExpertView || (showCallInfo$ | async)">
                  <div>
                     <ng-container *ngIf="callInfo$ | async">
                        <samweb-ici-type
                           style="padding: 0 0.35em 0 0.2em"
                           [conversationTypeAsSamwinValue]="(callInfo$ | async).type"
                           [iciDirectionType]="(callInfo$ | async).ici.ici"
                           [ici]="(callInfo$ | async).ici.ici"
                        ></samweb-ici-type>
                        {{ (callInfo$ | async).ici | iciToCallDirectionText }}
                     </ng-container>
                     <ng-container *ngIf="callInfo$ | async">
                        {{ (callInfo$ | async).ici | iciExtraInfoText }}
                     </ng-container>
                  </div>
                  <div></div>
               </div>
               <div fxFlex="1 1 auto" *ngIf="toggleExpertView || (showHistory$ | async)" fxLayout="row">
                  <div
                     class="history-info-icon"
                     *ngIf="
                        (currentSourceLineStateModel$ | async)?.dn !== '' &&
                        (currentSourceLineStateModel$ | async)?.history
                     "
                  >
                     <fa-icon class="sam-margin-right" [icon]="callHistoryIcon" [fixedWidth]="true"></fa-icon>
                  </div>
                  <div fxLayout="column" class="padding">
                     <ng-container *ngIf="(currentSourceLineStateModel$ | async)?.dn !== ''">
                        <div
                           *ngFor="let history of (currentSourceLineStateModel$ | async)?.history"
                           class="padding-bottom"
                        >
                           <samweb-ici-type
                              [conversationTypeAsSamwinValue]="(callInfo$ | async).type"
                              [ici]="history.ici"
                           ></samweb-ici-type>
                           {{ history.name }}
                           (<span (click)="call(history.number)" class="onhover">{{ history.number }}</span
                           >)
                           {{ history | iciText }}
                        </div>
                     </ng-container>
                     <ng-container *ngIf="(currentSourceLineStateModel$ | async).history?.length < 1">
                        <span style="opacity: 0.5">
                           {{ 'common.no-records-available' | translate }}
                        </span>
                     </ng-container>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <div fxFlex="20" class="line-buttons" fxLayout="row">
         <div class="button-container">
            <button
               class="content dial-control dial-control-accept"
               kendoButton
               (click)="acceptOrStartCall()"
               [disabled]="!(isCallRingingAndAcceptable$ | async)"
            >
               <div class="fa-layers" [ngClass]="{ 'sam-wiggle': isPhoneRinging$ | async }">
                  <fa-icon [icon]="answerIcon"></fa-icon>
               </div>
            </button>
         </div>
         <div class="button-container">
            <button
               class="content dial-control dial-control-hang-up"
               kendoButton
               (click)="disconnectLineA()"
               [disabled]="!((isCallInProgress$ | async) || (canDisconnectLineA$ | async))"
            >
               <div class="fa-layers">
                  <fa-icon [icon]="hangUpIcon"></fa-icon>
               </div>
            </button>
         </div>
         <div class="button-container">
            <button
               class="content dial-control dial-control-hold"
               kendoButton
               (click)="holdLine()"
               [disabled]="!(canToggleHoldLineA$ | async)"
               [ngClass]="{ hold: isLineAOnHold$ | async }"
            >
               <div class="fa-layers">
                  <fa-icon [icon]="holdIcon"></fa-icon>
               </div>
            </button>
         </div>
      </div>
   </div>
</div>
